<template>
  <div class="p-3 mb-5">
    <div ref="chartRef" style="width: 50%;height: 500px"></div>
  </div>
</template>

<script>
import {ref, onMounted} from 'vue'
import {useRoute} from 'vue-router'
import axios from 'axios'
import * as echarts from 'echarts'

function getOption(data) {
  return {
    title: {
      text: '冒烟有效率趋势(周)'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: data.y
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: data.x
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: data.y[0],
        type: 'line',
        data: data.series[0]
      },
      {
        name: data.y[1],
        type: 'line',
        data: data.series[1]
      },
      {
        name: data.y[2],
        type: 'line',
        data: data.series[2]
      },
    ]
  }
}

export default {
  setup() {
    const chartRef = ref(null)
    
    onMounted(async () => {
      const route = useRoute()
      const {data} = await axios(`report/smoke_statistics_by_week/?project=${route.query.project}`)

      const myChart = echarts.init(chartRef.value)
      myChart.setOption(getOption(data))
    })

    return {chartRef}
  }
}
</script>